import { useEffect } from "react"

import { Button, Text } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import { SKIP_APP_SELECT_PARAM } from "src/domains/session/use-redirect-to-app-select"
import { useSession } from "src/domains/session/use-session"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

import { AppSelectContent } from "./-app-select-content"

export const Route = createFileRoute("/app-select/")({
  component: AppSelect,
})

function AppSelect() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()
  const { sessions, isLoading } = useSession()

  // Safety net for a direct navigation or refresh with no active session: there
  // is nothing to select, so send the user back to the login form.
  useEffect(() => {
    if (!isLoading && sessions.length === 0) {
      void navigate({ to: "/" })
    }
  }, [isLoading, sessions.length, navigate])

  if (isLoading || sessions.length === 0) {
    return null
  }

  return (
    <PageLayout
      title={tPlaceholder("Choose an account")}
      description={tPlaceholder(
        "Choose which account to continue with or sign in with another account."
      )}
      footer={<Footer />}
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <AppSelectContent sessions={sessions} />
    </PageLayout>
  )
}

function Footer() {
  const { t, tPlaceholder, langKeys } = useTranslate()
  const navigate = useNavigate()

  function handleSignIn() {
    void navigate({
      to: "/login",
      search: { [SKIP_APP_SELECT_PARAM]: true },
    })
  }

  return (
    <Text variant="bodyS" color="secondary">
      {tPlaceholder("Want to use a different account?")}{" "}
      <Button
        variant="minimal"
        color="neutral"
        size="small"
        onClick={handleSignIn}
      >
        {t(langKeys.sign_in)}
      </Button>
    </Text>
  )
}
